var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"color":"#FFFFFF","opacity":"0.75","value":_vm.showOverlay,"z-index":'1000'/* above all others */}},[_c('sm-progress-circular',{attrs:{"size":"40"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }